import { Plugin } from '@nuxt/types'
import { Logger, initializeLogger } from '@/utils/logger'

const plugin: Plugin = (_, inject) => {
  const logger = new Logger
  initializeLogger(logger)
  inject('logger', logger)
}

export default plugin